import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[exchangeRate]'
})
export class ExchangeRateDirective {
  
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.el.nativeElement;
    let value: string = input.value;

    // Zamiana WSZYSTKICH przecinków na kropki
    value = value.replace(/,/g, '.');

    // Usunięcie wszystkich znaków oprócz cyfr i kropek
    value = value.replace(/[^0-9.]/g, '');

    // Usunięcie kropki na początku (kropka musi być po liczbie)
    if (value.startsWith('.')) {
      value = value.substring(1);
    }

    // Zachowanie tylko pierwszej kropki - usunięcie kolejnych
    const firstDotIndex = value.indexOf('.');
    if (firstDotIndex !== -1) {
      value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '');
    }

    // Ograniczenie do 5 miejsc po kropce
    const parts = value.split('.');
    if (parts[1] && parts[1].length > 5) {
      value = parts[0] + '.' + parts[1].slice(0, 5);
    }

    // Zaktualizowanie wartości inputa
    input.value = value;
  }

  // Usunięcie końcowej kropki przy opuszczeniu pola (np. "4." → "4")
  @HostListener('blur') onBlur() {
    const input = this.el.nativeElement;
    if (input.value.endsWith('.')) {
      input.value = input.value.slice(0, -1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Zapobieganie wprowadzaniu niedozwolonych znaków
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const allowedChars = /[0-9,.]/;

    // Zablokowanie innych znaków niż liczby, przecinek i kropka
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }
}
